<style lang="scss">


</style>

<template>
  <div class="focused-panel">
    <div class="d-flex centreline-toolbar">
      <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create Access Point"
             :pressed.sync="addEnabled" variant="primary">
        <icon scale=".6" name="plus"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select Point"
             :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Multi Select"
             :pressed.sync="multiEdit" variant="primary">
        <icon scale=".6" name="dice-two"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges"
             @click="undo" variant="primary">
        <icon scale=".6" name="undo"/>
      </b-btn>
      <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
        Undo
      </b-tooltip>


      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit geometry"
             :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled" variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes"
             :disabled="!wellFeatureSelected" :pressed.sync="editEnabled" variant="primary">
        <icon scale=".6" name="pencil-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto
             title="Delete Capture Point" :disabled="!wellFeatureSelected" variant="primary">
        <icon scale=".6" name="times"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" :pressed.sync="ldEnabled" v-b-tooltip.hover.auto
             title="Load dependant layers" variant="primary">
        <icon scale=".6" name="link"/>
      </b-btn>
    </div>

    <b-modal v-model="showForm" size="lg" no-close-on-backdrop no-close-on-esc id='capture-point-editor-modal'>
      <div slot="modal-header">
        <label>{{ formTitle }}</label>

      </div>

      <div class="p-2 pl-4">
        <b-form>
          <b-row>

            <b-col>
              <b-form-group label="Point Type:" label-for="etype">
                <b-form-select :options="etypes" id="etype"  v-model="wellAttrs['etype']"
                               placeholder="Please, select point type"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>

              <b-col>
                <b-form-group label="Comment:" label-for="description">
                  <b-textarea id="description" v-model="wellAttrs['description']" rows="3"></b-textarea>
                </b-form-group>
              </b-col>

          </b-row>

        </b-form>
      </div>
      <div slot="modal-footer" class="designatron-modal-footer w-100">
        <div role="group" class="btn-group">
          <b-btn size="sm"  variant="primary" @click="close" style="min-width:80px">
            Close
          </b-btn>
          <b-btn size="sm"  variant="success"
                 @click="onOK" style="min-width:80px">
            Save
          </b-btn>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
import 'vue-awesome/icons/list-ol'
import 'vue-awesome/icons/cut'
import 'vue-awesome/icons/compress'
import 'vue-awesome/icons/hand-pointer'
import 'vue-awesome/icons/undo'
import 'vue-awesome/icons/exchange-alt'
import 'vue-awesome/icons/bezier-curve'
import 'vue-awesome/icons/pencil-alt'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/clock'
import 'vue-awesome/icons/backward'
import 'vue-awesome/icons/lock'
import 'vue-awesome/icons/unlock'
import 'vue-awesome/icons/dice-two'
import Feature from 'ol/Feature'
import uuidV1 from 'uuid/v1'
import Vue from 'vue'
import {parallel} from 'async'

export default {
  name: 'access-point-editor',

  components: {},
  mixins: [FeatureEditorMixin],
  data() {
    return {
      idName: 'objectid',
      etypes: [
        'existing single gate', 'existing double gate'
      ],
      wellAttrs: {
        etype: null,
        description: ''
      },
      geomType: 'Point',
      wellLayerName: 'fr:access_points',
      multiEdit: false,
    }
  },
  created() {
    this.selectTool = null
  },

  methods: {
    validateIdent() {
      this.identState = true
    },
    close(evt) {
      this.wellFeature = null
      this.showForm = false
      this.onCancel()
    }
  },
  watch: {},
}
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/AccessPointsEditor.vue